import React, { useState, useEffect } from 'react';
import { budgetAPI } from '../services/api';
import './BudgetSummary.css';

const BudgetSummary = ({ houseId }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSummary();
  }, [houseId]);

  const loadSummary = async () => {
    try {
      setLoading(true);
      const response = await budgetAPI.getSummary(houseId);
      setSummary(response.data);
    } catch (error) {
      console.error('Error loading budget summary:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    }).format(amount);
  };

  if (loading) {
    return <div className="budget-summary-loading">Loading budget summary...</div>;
  }

  if (!summary) {
    return null;
  }

  return (
    <div className="budget-summary">
      <h3>💰 Budget Overview</h3>
      <div className="budget-summary-grid">
        <div className="budget-summary-card">
          <div className="budget-summary-icon">📦</div>
          <div className="budget-summary-content">
            <div className="budget-summary-label">Monthly Charges</div>
            <div className="budget-summary-value">{formatCurrency(summary.total_charges)}</div>
          </div>
        </div>

        <div className="budget-summary-card">
          <div className="budget-summary-icon">🏦</div>
          <div className="budget-summary-content">
            <div className="budget-summary-label">Loans</div>
            <div className="budget-summary-value">{formatCurrency(summary.total_loans)}</div>
          </div>
        </div>

        <div className="budget-summary-card">
          <div className="budget-summary-icon">💾</div>
          <div className="budget-summary-content">
            <div className="budget-summary-label">Savings</div>
            <div className="budget-summary-value">{formatCurrency(summary.total_savings)}</div>
          </div>
        </div>

        <div className="budget-summary-card total">
          <div className="budget-summary-icon">📊</div>
          <div className="budget-summary-content">
            <div className="budget-summary-label">Total Monthly</div>
            <div className="budget-summary-value">{formatCurrency(summary.total_monthly)}</div>
          </div>
        </div>
      </div>

      {summary.person_calculations && summary.person_calculations.length > 0 && (
        <div className="budget-people-summary">
          <h4>Per Person</h4>
          <div className="people-summary-grid">
            {summary.person_calculations.map((calc) => (
              <div key={calc.person_id} className="person-summary-card">
                <div className="person-summary-name">{calc.person_name}</div>
                <div className="person-summary-salary">Salary: {formatCurrency(calc.salary)}</div>
                <div className="person-summary-deductions">
                  Deductions: {formatCurrency(calc.total_deductions)}
                </div>
                <div className={`person-summary-remaining ${calc.remaining >= 0 ? 'positive' : 'negative'}`}>
                  Remaining: {formatCurrency(calc.remaining)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BudgetSummary;
